/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ResumeInputs */

const en_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const ar_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السيرة الذاتية`)
};

const bn_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সিভি`)
};

const de_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf`)
};

const es_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículum`)
};

const fr_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const pt_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículo`)
};

const zh_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简历`)
};

const tr_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özgeçmiş`)
};

const ru_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резюме`)
};

const pl_nav_resume = /** @type {(inputs: Nav_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Nav_ResumeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_resume = /** @type {((inputs?: Nav_ResumeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ResumeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_resume(inputs)
	if (locale === "bn") return bn_nav_resume(inputs)
	if (locale === "de") return de_nav_resume(inputs)
	if (locale === "es") return es_nav_resume(inputs)
	if (locale === "fr") return fr_nav_resume(inputs)
	if (locale === "pt") return pt_nav_resume(inputs)
	if (locale === "zh") return zh_nav_resume(inputs)
	if (locale === "tr") return tr_nav_resume(inputs)
	if (locale === "ru") return ru_nav_resume(inputs)
	if (locale === "pl") return pl_nav_resume(inputs)
	return en_nav_resume(inputs)
});